import { TemplateProps } from '@/components/template/resume/type';

export const CV_PREVIEW = {
  PADDING: 14,
  SCALE: {
    MIN: 0.3,
    MAX: 0.9,
  },
} as const;

export const DEFAULT_PDF_PREVIEW_DATA: TemplateProps['data'] = {
  info: {
    name: '',
    email: '',
    phone: '',
    bio: '',
    address: '',
    title: '',
    avatar: '',
    links: [],
  },
  journeys: [],
  technicalSkills: [],
  educations: [],
  certs: [],
};
